import {AuthProvider} from '@hconnect/login'
import {hpTheme, ErrorBoundary} from '@hconnect/uikit/src/lib2'
import {UpmPlantsProvider} from '@hconnect/upm'
import {
  FundamentalContextProvider,
  ThemeProvider as FundamentalThemeProvider,
  ToastContainer
} from '@hm/fundamental'
import {CssBaseline, ThemeProvider as MUIThemeProvider} from '@mui/material'
import {StrictMode, Suspense} from 'react'
import {HelmetProvider} from 'react-helmet-async'
import {useTranslation} from 'react-i18next'
import {BrowserRouter} from 'react-router'

import {Api} from '../../../api/api'
import {DefaultLoadingComponent} from '../components'

import {FundamentalThemeInitializer} from './FundamentalThemeInitializer'
import {LoginValidationWrapper} from './LoginValidationWrapper'
import {QueryProvider} from './QueryProvider'

import '../../../index.css'

interface AppProvidersProps {
  children: React.ReactNode
}

export const AppProviders: React.FC<AppProvidersProps> = ({children}) => {
  const {t} = useTranslation()

  return (
    <Suspense fallback={<DefaultLoadingComponent />}>
      <MUIThemeProvider theme={hpTheme}>
        <CssBaseline />
        <ErrorBoundary apology={t('error.apology')} resetText={t('error.startOver')}>
          <FundamentalContextProvider>
            <FundamentalThemeProvider>
              <FundamentalThemeInitializer />
              <ToastContainer />
              <HelmetProvider>
                <BrowserRouter>
                  <QueryProvider>
                    <AuthProvider>
                      <LoginValidationWrapper>
                        <UpmPlantsProvider api={Api.axiosInstance}>
                          <StrictMode>{children}</StrictMode>
                        </UpmPlantsProvider>
                      </LoginValidationWrapper>
                    </AuthProvider>
                  </QueryProvider>
                </BrowserRouter>
              </HelmetProvider>
            </FundamentalThemeProvider>
          </FundamentalContextProvider>
        </ErrorBoundary>
      </MUIThemeProvider>
    </Suspense>
  )
}
